<div class="p-5" fxLayout="row" style="height: 100vh; background-image: url('assets/background.jpg'); background-size: cover;">
  <div fxFlex="30" fxFlexOffset="70" fxFlexAlign="center">
    <router-outlet></router-outlet>
  </div>
</div>